/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

export type DialogContentAlignType = 'top' | 'middle' | 'bottom';

@Component({
  standalone: false,
  selector: 'gh-dialog-content',
  templateUrl: 'dialog-content.component.html',
  styleUrls: ['dialog-content.component.scss'],
})
export class DialogContentComponent implements OnInit {
  @Input() align: DialogContentAlignType = 'middle';

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) {

  }

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, `dialog-content-align-${this.align}`);
  }
}
